/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */

import React, { Component } from "react";
import PropTypes from "prop-types";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import useProminentNavigation from "../../ExperimentGate/useProminentNavigation";

// REDUX

import FullScreenHomepageProductsCategoryFilter from "../../ProductsCategoryFilter/FullScreenHomepageProductsCategoryFilter/FullScreenHomepageProductsCategoryFilter";

// HELPERS
import { MOBILE_SIZE } from "../../../shared/constants/size";
import { isBrandRefreshEnabled } from '../../../shared/utilities/brandRefresh';

import styles from "./FullScreenHomepageProductsHeader.module.css";
import stylesHeroBanner from "../../ContentCards/Carousel/Templates/HeroBanner/HeroPromoContentCardTemplate.module.css";
import * as elementsActions from "../../../redux/actions/elements";
import DeliveryPickUpWidget from "../../DeliveryPickUpWidget/DeliveryPickUpWidget";

// CONSTANTS
import { modalBox } from "../../../shared/constants/refs";
import elementConstants from "../../../shared/constants/element";
import ContentCardCarousel from "../../ContentCards/Carousel/ContentCardCarousel";
import * as contentCardConstants from "../../../shared/constants/contentCards";
import HeroBannerIntro from "../../ContentCards/Carousel/Templates/HeroBannerIntro/HeroBannerIntro";

const REDUCE_TIMEOUT_OFFSET = 500;

export class FullScreenHomepageProductsHeader extends Component {
  constructor(props) {
    super(props);
    this.state = {
      chosenItem: "Boxes",
      isMobile: false,
      choseItemToggle: false,
      isCategoryFilterSticky: false,
    };
    this.productMenuContainerRef = React.createRef();
  }

  componentDidMount() {
    this.updateSize();
    window.addEventListener("resize", this.updateSize);
  }

  componentDidUpdate(prevProps, prevState) {
    const { isCategoryFilterSticky } = this.state;

    if (prevState.isCategoryFilterSticky !== isCategoryFilterSticky) {
      this.handleStickyVisibilityChange(isCategoryFilterSticky);
    }
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.updateSize);
  }

  handleStickyVisibilityChange = (isSticky, navShouldBeVisible) => {
    const { isCategoryFilterSticky } = this.state;
    const { setHideHeaderMenuOnScroll } = this.props;
    if (isCategoryFilterSticky !== isSticky) {
      this.setState({ isCategoryFilterSticky: isSticky });
    }
    if (typeof navShouldBeVisible === "boolean" && setHideHeaderMenuOnScroll) {
      setHideHeaderMenuOnScroll(navShouldBeVisible);
    }
  };

  updateSize = () => {
    const width = window.innerWidth;
    if (width <= MOBILE_SIZE.width) {
      this.setState({ isMobile: true });
    } else {
      this.setState({ isMobile: false });
    }
  };

  mobileToggleWidget = (e) => {
    const { toggleHeaderWidget } = this.props;

    e.stopPropagation();
    toggleHeaderWidget();
  };

  scrollToProducts = () => {
    if (this.productMenuContainerRef.current) {
      const menuContainer = this.productMenuContainerRef.current;
      const top = menuContainer.offsetHeight - 50;
      window.scrollTo({ top: top, left: 0, behavior: "smooth" }); // eslint-disable-line
    }
  };

  productsMenuContainer = () => {
    const {
      showHeaderWidget,
      shouldDisplayIntroBanner,
      contentCardRefreshDelay,
      floatMenuHide,
      location,
      openDeliveryWidget,
      registerCategoryNavigationHandler,
      topHeaderOffsetDivHeight,
      prominentNavigation,
    } = this.props;

    const { isMobile, chosenItem, choseItemToggle, isCategoryFilterSticky } =
      this.state;
    const { hideHeaderMenuOnScroll } = this.props;

    // Calculate the correct sticky offset based on brand refresh and
    // whether the ribbon banner is currently visible. This ensures the
    // sticky category filter sits flush below the nav (+ ribbon) instead
    // of being hidden underneath it.
    const brandRefresh = isBrandRefreshEnabled();
    const ribbonVisible =
      (topHeaderOffsetDivHeight || elementConstants.topHeaderOffsetDivHeightDefault) > 99;
    let stickyOffsetTop;
    if (brandRefresh) {
      stickyOffsetTop = ribbonVisible ? 100 : 64;
    } else {
      stickyOffsetTop = ribbonVisible ? 108 : 68;
    }

    const cardCarousel = (
      <ContentCardCarousel
        templates={[
          contentCardConstants.HERO_PROMO_TEMPLATE,
          contentCardConstants.HERO_INTRO_PROMO_TEMPLATE,
          contentCardConstants.HERO_PROMO_IMAGE_TEMPLATE,
          contentCardConstants.HERO_PROMO_TEXT_TEMPLATE,
        ]}
        carouselControlStyles={stylesHeroBanner}
        delay={contentCardRefreshDelay + REDUCE_TIMEOUT_OFFSET}
        openDeliveryWidget={openDeliveryWidget}
      />
    );

    const heroBannerIntro = <HeroBannerIntro />;

    const bannerContent = shouldDisplayIntroBanner
      ? heroBannerIntro
      : cardCarousel;

    return (
      <div
        ref={this.productMenuContainerRef}
        className="flex flex-col gap-0 w-full border-0 rounded-none bg-transparent"
      >
        {showHeaderWidget && isMobile && !prominentNavigation ? (
          <div className={styles.widgetWrapper} ref={modalBox}>
            <DeliveryPickUpWidget />
          </div>
        ) : null}

        <div className={styles.heroBannerContainer}>{bannerContent}</div>
        {/* <div className={styles.productsHeaderContainer} /> */}
        {/* BANNER CONTAINER */}
        <div
          className={`${styles.productHeaderBanner} ${
            floatMenuHide ? "hidden" : "block"
          }`}
        >
          {/* MOBILE ADDRESS FINDER */}
          {/* Menu Header - not sticky */}
          <div className="w-full flex items-center justify-center mb-5 max-w-screen-desktop mx-auto md:px-0 px-4">
            <h1 className={isBrandRefreshEnabled() ? styles.menuTitle : 'font-congenialBlack text-4xl leading-9 tracking-[-1px] text-dark dark:text-white'}>
              Menu
            </h1>
          </div>
          {/* Category Filter - becomes sticky */}
          {!isMobile || (!showHeaderWidget && isMobile) ? (
            <div
              className={
                isCategoryFilterSticky ? styles.categoriesWrapperSticky : ""
              }
              style={
                isCategoryFilterSticky
                  ? { top: (prominentNavigation || hideHeaderMenuOnScroll) ? stickyOffsetTop : 0 }
                  : undefined
              }
            >
              <div
                className={`${styles.categoriesWrapper} max-w-screen-desktop border-0 rounded-none mx-auto md:px-0 px-4`}
              >
                <FullScreenHomepageProductsCategoryFilter
                  persistentNavigation={prominentNavigation}
                  navigationHeight={stickyOffsetTop}
                  location={location}
                  onChange={(product) =>
                    this.setState({
                      chosenItem: product,
                      choseItemToggle: !choseItemToggle,
                    })}
                  onStickyVisibilityChange={this.handleStickyVisibilityChange}
                  registerCategoryNavigationHandler={
                    registerCategoryNavigationHandler
                  }
                  chosenItem={chosenItem}
                />
              </div>
            </div>
          ) : null}
        </div>
      </div>
    );
  };

  render() {
    return <this.productsMenuContainer />;
  }
}

FullScreenHomepageProductsHeader.propTypes = {
  prominentNavigation: PropTypes.bool,
  history: PropTypes.shape({
    push: PropTypes.func.isRequired,
  }).isRequired,
  location: PropTypes.shape({
    pathname: PropTypes.string,
  }),
  selectedStore: PropTypes.shape({
    name: PropTypes.string.isRequired,
  }),
  toggleHeaderWidget: PropTypes.func,
  showHeaderWidget: PropTypes.bool,
  shouldDisplayIntroBanner: PropTypes.bool.isRequired,
  contentCardRefreshDelay: PropTypes.number.isRequired,
  floatMenuHide: PropTypes.string,
  openDeliveryWidget: PropTypes.func,
  setHideHeaderMenuOnScroll: PropTypes.func,
  hideHeaderMenuOnScroll: PropTypes.bool,
  registerCategoryNavigationHandler: PropTypes.func,
  topHeaderOffsetDivHeight: PropTypes.number,
};

FullScreenHomepageProductsHeader.defaultProps = {
  prominentNavigation: false,
  selectedStore: null,
  toggleHeaderWidget: null,
  showHeaderWidget: null,
  floatMenuHide: null,
  location: undefined,
  openDeliveryWidget: null,
  setHideHeaderMenuOnScroll: null,
  hideHeaderMenuOnScroll: true,
  registerCategoryNavigationHandler: null,
  topHeaderOffsetDivHeight: elementConstants.topHeaderOffsetDivHeightDefault,
};

export const mapStateToProps = (state) => {
  const {
    showHeaderWidget,
    hideHeaderMenuOnScroll,
    topHeaderOffsetDivHeight,
  } = state.elements;
  const {
    userOrderMethod,
    userAddress,
    selectedStore,
    userToken,
    orderCompleted,
  } = state.user;

  const { shouldDisplayIntroBanner, contentCardRefreshDelay } = state.braze;
  return {
    showHeaderWidget,
    hideHeaderMenuOnScroll,
    topHeaderOffsetDivHeight,
    userOrderMethod,
    userAddress,
    selectedStore,
    userToken,
    orderCompleted,
    shouldDisplayIntroBanner,
    contentCardRefreshDelay,
  };
};

export const mapDispatchToProps = (dispatch) => ({
  toggleHeaderWidget: () => dispatch(elementsActions.toggleHeaderWidget()),
  setProductCategory: (value) =>
    dispatch(elementsActions.setProductCategory(value)),
  setHideHeaderMenuOnScroll: (value) =>
    dispatch(elementsActions.setHideHeaderMenuOnScroll(value)),
});

const ExperimentProductsHeader = (props) => {
  const prominentNavigation = useProminentNavigation();
  // eslint-disable-next-line react/jsx-props-no-spreading
  return <FullScreenHomepageProductsHeader {...props} prominentNavigation={prominentNavigation} />;
};

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  )(ExperimentProductsHeader),
);
